import { ReactElement, SVGProps } from 'react'
export const SvgTelegram = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 0A15.998 15.998 0 0 0 0 16a16.005 16.005 0 0 0 16 16 15.998 15.998 0 0 0 16-16A16.005 16.005 0 0 0 16 0Z"
      fill="#2AABEE"
    />
    <path
      d="M7.242 15.83c4.666-2.032 7.776-3.372 9.33-4.019 4.445-1.848 5.368-2.17 5.97-2.18.133-.002.428.03.62.186.16.131.206.309.228.434.02.124.047.408.025.63-.24 2.53-1.282 8.669-1.813 11.503-.222 1.199-.665 1.6-1.092 1.64-.93.085-1.635-.614-2.535-1.204-1.408-.923-2.203-1.498-3.57-2.398-1.58-1.041-.555-1.614.345-2.549.235-.244 4.33-3.968 4.407-4.306.01-.042.02-.2-.075-.283-.092-.083-.23-.054-.33-.032-.142.032-2.39 1.52-6.75 4.46-.637.44-1.215.653-1.735.642-.57-.012-1.67-.323-2.487-.589-1-.325-1.798-.498-1.728-1.05.036-.289.433-.584 1.19-.885Z"
      fill="#fff"
    />
  </svg>
)
